import React, { useEffect, useState } from 'react';
import { PromptContext } from './context';

// TODO: remove, add to Install instead
export default function InstallPromptProvider(props) {
    const [deferredPrompt, setDeferredPrompt] = useState(null);

    useEffect(() => {
        function handlePrompt(e) {
            e.preventDefault && e.preventDefault();
            setDeferredPrompt(e);
        }

        window.addEventListener('beforeinstallprompt', handlePrompt);

        return () => window.removeEventListener('beforeinstallprompt', handlePrompt);
    });

    return <PromptContext.Provider value={deferredPrompt} {...props} />;
}
